<template>
    <div>
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                { text: 'Riwayat Konsul' },
            ]"
            divider="|"
        ></v-breadcrumbs>

        <div class="font-weight-bold font-size-20 mt-3 mb-4">
            Riwayat Konsul
        </div>

        <consul-chat-list />
    </div>
</template>

<script>
import ConsulChatList from "./components/ConsulChatList.vue";

export default {
    name: "consul-chat",
    components: {
        ConsulChatList,
    },

    data() {
        return {
            loading: false,
        };
    },
};
</script>



// WEBPACK FOOTER //
// ConsulChat.vue?39c2621a